import {useEffect, useState} from "react";
import {useUser} from "../../../auth/AuthProvider";
import axios from "axios";
import {ApiUrl} from "../../../auth/authMethods";
import {LineChart} from "@mui/x-charts";
import BasicLoader from "../../../component/BasicLoader/BasicLoader";
import {numberWithPoints} from "../../../utils/numberWithPoints";
import Select from "react-select";
import * as React from "react";


export default function ProjectionGraph() {
    const [isLoading, setIsLoading] = useState(true);
    const [responseData, setResponseData] = useState([]);

    const {user} = useUser()

    const [key, setKey] = useState('throwbacks');

    const options = [
        {value: 'projections', label: 'Projeção próximos 12 meses'},
        {value: 'throwbacks', label: 'Retrospecto últimos 12 meses'},
    ]

    useEffect(() => {
        setIsLoading(true)
        axios.defaults.headers.common['Authorization'] = `Bearer ${user?.token}`;
        axios
            .get(`${ApiUrl}/dashboard/${key}`)
            .then(function (response) {

                setResponseData(response.data);
            }).finally(() => setIsLoading(false))
    }, [key]);

    console.log({responseData});


    // Dados separados por linhas
    const labels = responseData.map((item) => item.month);
    const valuesToReceive = responseData.map((item) => Number(item.valueToReceive));
    const valuesReceived = responseData.map((item) => Number(item.valueReceived));
    const valuesRepassed = responseData.map((item) => Number(item.valueRepassed));
    const valuesToRepass = responseData.map((item) => Number(item.valueToRepass));
    const lucros = responseData.map((item) => Number(item.lucro));



    return isLoading ? <BasicLoader /> : (
        <>
            <div className="w-100 mt-4 d-flex justify-content-center mb-4">
                <p className={'mt-2 mb-0'}>Gráficos com base em: </p>
                &nbsp;&nbsp;
                <Select
                    options={options}
                    value={options.find(option => option.value === key)}
                    onChange={item => setKey(item.value)}
                />
            </div>

                    <LineChart
                        title={key === 'projections' ? 'Projeção' : 'Retrocesso'}
                        series={[
                            {
                                color: "#00a6ff",
                                data: key === 'projections' ? valuesToReceive : valuesReceived,
                                label: key === 'projections' ? 'Valor à Receber' : "Valores Recebidos",
                                valueFormatter: (value) => `R$ ${numberWithPoints(value.toFixed(2))}`,
                            },
                            {
                                color: "#ff6961",
                                data: key === 'projections' ? valuesToRepass : valuesRepassed,
                                label: key === 'projections' ? 'Valor à Repassar' : 'Valores Repassados',
                                valueFormatter: (value) => `R$ ${numberWithPoints(value.toFixed(2))}`,
                            },
                        ]}
                        xAxis={[{scaleType: 'point', data: labels}]}
                        height={400}
                        width={600}
                    />
                    <LineChart
                        series={[
                            {
                                color: "#77dd77",
                                data: lucros, label: 'Lucro',
                                valueFormatter: (value) => `R$ ${numberWithPoints(value.toFixed(2))}`,
                            },
                        ]}
                        xAxis={[{scaleType: 'point', data: labels}]}
                        height={400}
                        width={600}
                    />
        </>
    );

}